import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import AppConstants from '../constants/app.constants';

export const AuthGuard: CanActivateFn = async () => {
    
    const router = inject(Router);
    const storageService = inject(StorageService);
 const token = await storageService.getItemIonic(AppConstants.AUTH_TOKEN);
    if (!token) {
        return router.navigateByUrl('/auth/login', { replaceUrl: true });
    }

    return true;
};
